function showBendingCheckSummary() {
    var design = activeProject.design;
    var checks = g_results["bending_checks"];
    var controlling_unity = checks["controlling_unity"];
    var controlling_case = checks["controlling_case"];
    var controlling_Mu = checks["controlling_Mu"];
    var controlling_Mn = checks["controlling_Mn"];
    var controlling_equation = checks["controlling_code_equation"];
    var controlling_case = checks["controlling_case"];
    var controlling_location = checks["controlling_loc"];
    var controlling_Lb = checks["controlling_Lb"];
    
    const nice_eq_index = Number(controlling_case.split('EQ')[1])

    var nice_case = design.loadCombination["prettyEquations"][nice_eq_index-1]["EQ"];
    var success = controlling_unity < 1.0;
    var designStatusStr = success ? '<i class="fa-solid fa-check text-success"></i>' : '<i class="fa-solid fa-xmark text-danger"></i>';
    
    setDesignPanelSuccessOrFail(success, '#bending-design-panel');

    let str = String.raw`
        <div class="card-header">
            <h4 class="panel-title">
                <span class="float-start">${designStatusStr} Bending</span>
                <span class="float-end">${controlling_unity.toFixed(2)}</span>
            </h4>
        </div>`

    
    str += "<table class='table'>"

    let label = "Mu (Demand)"
    if(activeProject.isEngineeredLumber) {
        label = "Mu (Demand)"
    } else if(activeProject.isASD) {
        label = "Ma (Demand)"
    }

    str += makeSummaryRow(label, `${showBigMoment(controlling_Mu)} ${bigMomentUnit()}`)

    label = "&Phi; Mn (Capacity)"

    if(activeProject.isEngineeredLumber) {
        str += "Mn (Capacity)";
    } else if(activeProject.isASD) {
        str += "Mn/&Omega; (Capacity)";
    } else if(activeProject.isNoDesign) {
        str += "Mn (Capacity)";
    } 

    str += makeSummaryRow(label, `${showBigMoment(controlling_Mn)} ${bigMomentUnit()}`)
    
    label = 'Controlling Equation'
    let value = controlling_equation

    if(activeProject.isEngineeredLumber) {
        value = 'Mu &le; Mn'
    } else if(activeProject.isFormTechShape) {
        value = controlling_equation
    } else if(activeProject.isNoDesign) {
        value = 'Mn = Fy &bull; Zx'
    } 

    str += makeSummaryRow(label, value)

    str += makeSummaryRow('Location', showLengthWithUnits(controlling_location))
    
    str += makeSummaryRow('Load Combination', nice_case)
    
    
    if(activeProject.isEngineeredLumber) {
        str += makeSummaryRow('Lb', 'Assumed Continuous')
    } else if(design.bracingType === 'unbraced' && design.designType !== 'None' ) {
        str += makeSummaryRow('Lb (Unbraced)', showLengthWithUnits(activeProject.beam.TotalLength()))
    } else if(design.bracingType !== 'continuous' && design.designType !== 'None' ) {
        str += makeSummaryRow('Lb', showLengthWithUnits(controlling_Lb))
    }

    str += "</table>";
    document.getElementById('bending-design-panel').innerHTML = str
}
